import React from "react";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";

type Props = {};

const ChangeWeightButton = (props: Props) => {
  const { onOpenChangeWeightHandler } = useConveyorBoxHandlers();
  return (
    <Button
      content="Ändra vikt"
      size="big"
      aria-label="Ändra vikt"
      icon="weight"
      onClick={onOpenChangeWeightHandler}
    />
  );
};

export default ChangeWeightButton;
